import {HttpRequest,HttpMethod} from "./http";

class OrderFixStatusBatchProvider extends HttpRequest {

    // Start a batch job that moves orders from source_statuses -> 130 (Completed).
    // Payload shape:
    //   { ids: [int] }              — selected scope
    //   { filter: { ... }, source_statuses: [int] }  — filter scope
    start(payload) {
        return this.request(HttpMethod.Post, `/api/v1/orders/fix-status-batch`, payload);
    }

    // Poll the status of a running / recent job.
    pollStatus(jobId) {
        return this.request(HttpMethod.Get, `/api/v1/orders/fix-status-batch/${jobId}`);
    }
}

export default OrderFixStatusBatchProvider;
